export default __webpack_public_path__ + "assets/fonts/6622a8f932a368b5c613d13cc4df241f.woff";